var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { setHSLLighness } from '../../utilities';
export var CardContainer = styled.article.attrs(function (_a) {
    var height = _a.height, hover = _a.hover, width = _a.width;
    return ({
        height: height,
        hover: hover,
        width: width,
    });
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (props) {
    var height = props.height, hover = props.hover, theme = props.theme, width = props.width;
    return "\n      background-color: " + (theme === null || theme === void 0 ? void 0 : theme.color.background.background) + ";\n      color: " + (theme === null || theme === void 0 ? void 0 : theme.color.background.foreground) + ";\n      border-radius: " + (theme === null || theme === void 0 ? void 0 : theme.size.radius.small) + ";\n      display: flex;\n      flex-flow: column;\n      font-family: " + (theme === null || theme === void 0 ? void 0 : theme.font.primary.family) + ";\n      height: " + (height ? height + "px" : 'initial') + ";\n      min-height: " + (height ? height + "px" : 'initial') + ";\n      min-width: " + (width ? width + "px" : 'initial') + ";\n      overflow: hidden;\n      width: " + (width ? width + "px" : 'initial') + ";\n\n      &:hover {\n        background-color: " + (hover ? setHSLLighness(theme === null || theme === void 0 ? void 0 : theme.color.background.background, 98) : theme === null || theme === void 0 ? void 0 : theme.color.background.background) + ";\n        cursor: " + (hover ? 'pointer' : 'auto') + ";\n      }\n    ";
});
export var CardContent = styled.section.attrs(function (_a) {
    var removePadding = _a.removePadding;
    return ({
        removePadding: removePadding,
    });
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (props) {
    var removePadding = props.removePadding, theme = props.theme;
    var spacerMedium = theme === null || theme === void 0 ? void 0 : theme.size.spacer.medium;
    var spacerSmall = theme === null || theme === void 0 ? void 0 : theme.size.spacer.small;
    return "\n      padding: " + (!removePadding ? spacerMedium : '0') + ";\n\n      > * {\n        position: static;\n      }\n\n      @media only screen and (max-width: 600px) {\n        padding: " + (!removePadding ? spacerSmall : '0') + ";\n      }\n    ";
});
export function SACardVariantSub(_a) {
    var children = _a.children, height = _a.height, onSubVariantClick = _a.onSubVariantClick, removePadding = _a.removePadding, width = _a.width, rest = __rest(_a, ["children", "height", "onSubVariantClick", "removePadding", "width"]);
    if (onSubVariantClick) {
        // TODO: Look into accessibilty options to make this more noticable as clickable to screen readers.
        return (React.createElement(CardContainer, __assign({ height: height, hover: true, width: width, onClick: onSubVariantClick }, rest),
            React.createElement(CardContent, { removePadding: removePadding }, children)));
    }
    return (React.createElement(CardContainer, __assign({ height: height, width: width }, rest),
        React.createElement(CardContent, { removePadding: removePadding }, children)));
}
var templateObject_1, templateObject_2;
//# sourceMappingURL=card.variant.sub.component.js.map